import { render, staticRenderFns } from "./StandardClauseEdit.vue?vue&type=template&id=3bab28e6&scoped=true&"
import script from "./StandardClauseEdit.vue?vue&type=script&lang=js&"
export * from "./StandardClauseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bab28e6",
  null
  
)

export default component.exports